<template>
  <!-- header START here -->
  <header>
    <!-- container START here -->
    <div class="container">
      <!-- logo START here -->
      <div id="logo">
        <h1>
          <router-link :to="{ name: 'home' }">
            <div class="sprite stumpthespread" />
          </router-link>
        </h1>
      </div>
      <!-- logo END here -->

      <div id="login-holder">
        <div v-show="!currentUser">
          <a id="login-link" href="#login-box" class="sml-btn green">Login</a>
          <router-link :to="{ path: '/register' }" class="sml-btn red">
            Register For Free
          </router-link>
        </div>
        <div v-if="currentUser">
          {{ currentUser.email }} &nbsp;&nbsp;
          <router-link :to="{ path: '/viewpicks' }" style="color: red">
            View Picks
          </router-link>
          <br />
          <div align="right">
            <a href="" style="color: grey" @click.prevent="logout()">Logout</a>
            &nbsp; &nbsp;
            <router-link
              v-if="!currentUser.admin"
              :to="{ path: '/myaccount' }"
              style="color: grey"
            >
              My Account
            </router-link>
            <router-link v-if="currentUser.admin" :to="{ path: '/admin' }">
              <font color="grey">
                Admin
              </font>
            </router-link>
            <!-- <input id="user_id" type="hidden" v-model="currentUser.id"/> -->
          </div>
        </div>
      </div>
      <!-- navigation START here -->
      <div style="padding-top: 4px">
        <ul class="sf-menu">
          <li :class="{ current_page_item: this.$route.name === 'home' }">
            <router-link :to="{ name: 'home' }">
              Home
            </router-link>
          </li>
          <li
            :class="{
              current_page_item: this.$route.path.indexOf('packages') > 0,
            }"
          >
            <router-link :to="{ path: '/packages/all' }">
              Premium Picks
            </router-link>
            <ul>
              <li>
                <router-link :to="{ path: '/packages/all' }">
                  All Sports Packages
                </router-link>
              </li>
              <li>
                <router-link :to="{ path: '/packages/nfl' }">
                  NFL Packages
                </router-link>
              </li>
              <li>
                <router-link :to="{ path: '/packages/ncaaf' }">
                  NCAAF Packages
                </router-link>
              </li>
              <li>
                <router-link :to="{ path: '/packages/nba' }">
                  NBA Packages
                </router-link>
              </li>
              <li>
                <router-link :to="{ path: '/packages/ncaab' }">
                  NCAAB Packages
                </router-link>
              </li>
              <li>
                <router-link :to="{ path: '/packages/mlb' }">
                  MLB Packages
                </router-link>
              </li>
              <li>
                <router-link :to="{ path: '/packages/nhl' }">
                  NHL Packages
                </router-link>
              </li>
            </ul>
          </li>
          <li :class="{ current_page_item: this.$route.name === 'freepicks' }">
            <router-link :to="{ name: 'freepicks' }">
              Free Picks
            </router-link>
          </li>
          <!--           <li :class="{current_page_item: this.$route.name === 'results'}"><router-link :to="{path: '/results'}">Results</router-link></li> -->
          <li :class="{ current_page_item: this.$route.name === 'blog' }">
            <router-link :to="{ path: '/blog' }">
              Blog
            </router-link>
          </li>
          <li :class="{ current_page_item: this.$route.name === 'contact' }">
            <router-link :to="{ path: '/contact' }">
              Contact
            </router-link>
          </li>
          <li
            :class="{ current_page_item: this.$route.name === 'testimonials' }"
          >
            <router-link :to="{ path: '/testimonials' }">
              Testimonials
            </router-link>
          </li>
          <li :class="{ current_page_item: this.$route.name === 'faq' }">
            <router-link :to="{ path: '/faq' }">
              FAQ
            </router-link>
          </li>
          <li :class="{ current_page_item: this.$route.name === 'odds' }">
            <router-link :to="{ path: '/odds' }">
              Odds
            </router-link>
          </li>
          <li>
            <router-link to="#">
              Tools
            </router-link>
            <ul>
              <li>
                <router-link :to="{ path: '/tools/size' }">
                  Bet Sizing Calculator
                </router-link>
              </li>
            </ul>
          </li>
          <li :class="{ current_page_item: this.$route.path.indexOf('shop') > -1 || this.$route.path.indexOf('cart') > -1 }" class="shop-menu-item">
            <router-link :to="currentUser && cartItemCount > 0 ? '/cart' : { name: 'shop' }">
              Shop
              <span v-if="currentUser && cartItemCount > 0" class="cart-badge">{{ cartItemCount }}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- navigation END here -->
      <div v-if="!isHome && bc" id="pagename">
        <div class="inside">
          <h2>{{ bc.meta.breadcrumb }}</h2>
          <p class="breadcrumbs">
            You are here :
            <router-link :to="{ path: '/' }">
              Home
            </router-link>
            / {{ params.sport ? params.sport.toUpperCase() : bc.meta.subtitle }}
          </p>
        </div>
      </div>
      <!-- slider-holder START here -->
      <div v-if="isHome" id="slider-holder">
        <div id="slider-nav-container">
          <div id="slider-nav" />
          <div class="sprite slider-nav-right" style="float: left" />
        </div>
        <div id="slider">
          <!-- slide1 START here -->
          <div class="slide">
            <div class="inside">
              <div
                class="sprite stsbutton slide-img"
                width="200"
                height="200"
              />
              <h2>Free Pick</h2>
              <p v-if="pick">
                {{ pick.title }}
              </p>
              <p
                v-if="pick"
                id="freePickContent"
                class="truncate"
                v-html="pick.content"
              />
              <router-link :to="{ name: 'freepicks' }" class="big-btn grey">
                More Free Picks
              </router-link>>
              <router-link :to="{ path: '/register' }" class="big-btn black">
                Become a Free Member
              </router-link>
              <router-link :to="{ path: '/packages/all' }" class="big-btn red">
                Buy Premium Picks
              </router-link>
            </div>
          </div>
          <!-- slide1 END here -->
          <!-- slide2 START here -->
          <div class="slide">
            <div class="inside">
              <div class="sprite stsblue slide-img" width="200" height="200" />
              <h2>NHL Full Season Package</h2>
              <p>
                STS is ready to dominate the ice this season. Our team has
                poured hundreds of hours over the offseason to make sure we are
                delivering the best hockey picks possible. No team is more
                prepared for the 2019-2020 hockey season! Get $100 off our Full
                NHL Season Package which includes premium picks every single day
                and playoff picks. This is a 33% saving! Join today, offer ends
                a week before the regular season!<router-link
                  :to="{ path: '/packages/nhl' }"
                >
                  <font color="green">
                    Purchase a full NHL season for $299.99!
                  </font>
                </router-link>
              </p>
              <router-link :to="{ path: '/packages/nhl' }" class="big-btn red">
                Purchase NHL Full Season Package
              </router-link>
            </div>
          </div>
          <!-- slide2 END here -->
          <!-- slide3 START here -->
          <div class="slide">
            <div class="inside">
              <div class="sprite stsredcheck slide-img" />
              <h2>NCAAB Full Season Package</h2>
              <p>
                NCAAB continues to be one of our big money makers at
                Stumpthespread. We’ve consistently put up strong profits year in
                and year out in college basketball racking up nearly +500 units
                all time. Last season we sprinted to the finish over the last
                two months putting up +150 units through February and March, and
                we’re looking to carry over that momentum into this campaign.
              </p>
              <router-link
                :to="{ path: '/packages/ncaab' }"
                class="big-btn red"
              >
                Purchase NCAAB Full Season Package
              </router-link>
            </div>
          </div>
          <div class="slide">
            <div class="inside">
              <div class="sprite stspoker slide-img" />
              <h2>Testimonials</h2>
              <p>You Will Win!</p>
              <p v-if="testimonial">
                {{ testimonial.content }}
              </p>
              <router-link :to="{ name: 'freepicks' }" class="big-btn grey">
                More Free Picks
              </router-link>>
              <router-link :to="{ path: '/register' }" class="big-btn black">
                Become a Free Member
              </router-link>
              <router-link :to="{ path: '/packages/all' }" class="big-btn red">
                Buy Premium Picks
              </router-link>
            </div>
          </div>
          <!-- slide4 END here -->
        </div>
      </div>
      <!-- slider-holder END here -->
    </div>
  </header>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import TestimonialRepository from "../data/testimonial.repository.js";
export default {
  name: "StsHeader",
  data() {
    return {
      testimonial: "",
    };
  },
  computed: {
    ...mapGetters(["cartItemCount"]),
    isHome() {
      return this.$route.name === "home";
    },
    params() {
      return this.$route.params;
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    bc() {
      return this.$breadcrumbs.slice(-1).pop();
    },
    pick() {
      return _.head(this.$store.state.picks) || {};
    },
  },
  watch: {
    isHome(val) {
      if (val) {
        this.$nextTick(() => {
          jQuery("#slider").cycle({
            // eslint-disable-line
            timeout: 10000, // milliseconds between slide transitions
            pager: "#slider-nav",
            fx: "fade", // choose your transition type, ex: fade, scrollUp, shuffle, etc...
          });
          var module = document.getElementById("freePickContent");
          if (module) $clamp(module, { clamp: 3 });
        });
      }
    },
    pick(val) {
      if (val) {
        this.$nextTick(() => {
          var module = document.getElementById("freePickContent");
          if (module) $clamp(module, { clamp: 3 });
        });
      }
    },
  },
  mounted() {
    jQuery("#login-link").first().fancybox();
    jQuery(document).ready(function () {
      jQuery("#slider").cycle({
        timeout: 10000, // milliseconds between slide transitions
        pager: "#slider-nav",
        fx: "fade", // choose your transition type, ex: fade, scrollUp, shuffle, etc...
      });
    });
    TestimonialRepository.getTestimonials(1).then((test) => {
      this.testimonial = test;
    });
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      if (
        this.$route.name === "myaccount" ||
        this.$route.name === "changepassword" ||
        this.$route.name === "picks"
      )
        this.$router.push("/");
    },
  },
};
</script>

<style lang="css" scoped>
.shop-menu-item {
  position: relative;
}

.cart-badge {
  position: absolute;
  top: -4px;
  right: -12px;
  background: #e53e3e;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: bold;
  min-width: 18px;
  text-align: center;
  line-height: 1.2;
}
</style>



// WEBPACK FOOTER //
// StsHeader.vue?0007a096